import styled, { css } from 'styled-components';
import { AvailableIcon, CrossIcon } from '@sainsburys-tech/bolt-icons';
var Widget = styled.div.withConfig({
  displayName: "GoInStoreWidgetstyles__Widget",
  componentId: "sc-1kd9jpm-0"
})(["position:relative;height:70px;margin-top:20px;cursor:pointer;"]);
var Box = styled.div.withConfig({
  displayName: "GoInStoreWidgetstyles__Box",
  componentId: "sc-1kd9jpm-1"
})(["position:absolute;width:calc(100% - 35px);margin-top:3px;margin-left:35px;height:63px;padding:11px 11px 11px 45px;border-radius:3px;", " > p{font-size:14px;line-height:1rem;}"], function (props) {
  switch (props.brand) {
    case 'samsung':
      return css(["color:white;background:#1428a0;padding-right:50px;p::after{position:absolute;right:12px;bottom:8px;width:75.68px;height:15.31px;content:' ';}"]);

    case 'microsoft':
      return css(["color:white;background:#000;padding-right:50px;p::after{position:absolute;right:12px;bottom:8px;width:84.14px;height:19px;content:' ';}"]);

    case 'hp':
      return css(["color:white;background:#0096d6;padding-right:50px;p::after{position:absolute;right:9px;bottom:7px;width:24px;height:24px;content:' ';}"]);

    case 'lg':
      return css(["color:#000;background:#fff;padding:10px 60px 7px 45px;box-shadow:0 -3px 6px 0 rgba(51,51,51,0.2),0 4px 4px 0 rgba(0,0,0,0.25);> p{u{color:#1976d2;}}> div{position:absolute;right:8px;bottom:7px;margin:0;padding:0;}"]);

    default:
      return css(["margin-top:5px;height:54px;color:white;background:", ";"], props.theme.color.palette['brand-1']);
  }
});
var Circle = styled.div.withConfig({
  displayName: "GoInStoreWidgetstyles__Circle",
  componentId: "sc-1kd9jpm-2"
})(["position:absolute;background-size:cover;background-origin:content-box;border-radius:50%;border:2px solid ", ";height:70px;width:70px;z-index:20;", ""], function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  switch (props.brand) {
    case 'samsung':
      return css(["border-color:#1428a0;background-image:", ";"], props.clerkImage);

    case 'microsoft':
      return css(["border-color:#000;background-image:", ";"], props.clerkImage);

    case 'hp':
      return css(["border-color:#0096d6;background-image:", ";"], props.clerkImage);

    case 'lg':
      return css(["border-color:#000;background-image:", ";"], props.clerkImage);

    default:
      return css(["background-image:", ";"], props.clerkImage);
  }
});
var AvailabilityCircle = styled.div.withConfig({
  displayName: "GoInStoreWidgetstyles__AvailabilityCircle",
  componentId: "sc-1kd9jpm-3"
})(["position:absolute;bottom:0;right:0;height:16px;width:16px;border-radius:10px;", ""], function (props) {
  return css(["background:", ";"], props.active ? props.theme.color.palette.green : props.theme.color.monochrome.dark);
});
var IconStyles = css(["position:absolute;bottom:0;right:0;z-index:5;fill:white;"]);
var IconAvailable = styled(AvailableIcon).withConfig({
  displayName: "GoInStoreWidgetstyles__IconAvailable",
  componentId: "sc-1kd9jpm-4"
})(["", ""], IconStyles);
var IconNotAvailable = styled(CrossIcon).withConfig({
  displayName: "GoInStoreWidgetstyles__IconNotAvailable",
  componentId: "sc-1kd9jpm-5"
})(["", ""], IconStyles);
var Content = styled.div.withConfig({
  displayName: "GoInStoreWidgetstyles__Content",
  componentId: "sc-1kd9jpm-6"
})(["display:flex;flex-direction:column;flex-grow:1;background-size:contain;background-color:", ";padding:20px;margin-bottom:20px;text-align:left;p{font-weight:normal;margin-bottom:0;font-size:16px;}"], function (props) {
  return props.theme.color.monochrome.lighter;
});
var ContentLink = styled.a.withConfig({
  displayName: "GoInStoreWidgetstyles__ContentLink",
  componentId: "sc-1kd9jpm-7"
})(["display:flex;flex-direction:row;flex-grow:1;background-size:contain;margin-bottom:10px;text-align:left;text-decoration:underline;color:#1976d2;"]);
export { Widget, Box, Circle, Content, ContentLink, AvailabilityCircle, IconAvailable, IconNotAvailable };